import { CSSProperties, ElementType, ReactNode } from 'react';
import clsx from 'clsx';
import { Text } from './components/Text';
import { getPropsByBreed } from './a-text.config';

export type ATextSizeProps =
  | '2xs'
  | 'xs'
  | 's'
  | 'm'
  | 'l'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl';

export interface ATextProps {
  intent?:
    | 'color_1'
    | 'color_2'
    | 'color_3'
    | 'color_4'
    | 'color_5'
    | 'color_6'
    | 'color_7'
    | 'color_error';
  color?: string;
  size?: ATextSizeProps;
  breed?: 'R' | 'RU' | 'B' | 'BU';
  transform?: 'capitalize' | 'lowercase' | 'uppercase' | 'initial';
  decoration?: 'none' | 'underline' | 'overline' | 'line-through';
  component?: ElementType;
  align?: 'left' | 'right' | 'center';
  breakWord?: 'break-all' | 'break-word' | 'keep-all' | 'normal';
  children?: ReactNode;
  overflow?: 'ellipsis' | 'hidden';
  typeface?: 'base';
  inject?: boolean;
  className?: string;
  danger?: boolean;
  style?: CSSProperties;
  ['data-role']?: string;
  htmlFor?: string;
  // Link components
  href?: string;
  target?: string;
  rel?: string;
  semibold?: boolean;
  [key: string]: unknown;
}

export const AText = (props: ATextProps) => {
  const { className: propClassName = '', breed, size = 'm', ...rest } = props;

  if (!breed) {
    return <Text {...props} />;
  }

  const { className: breedClassName = '', ...breedProps } = getPropsByBreed(
    breed,
    size
  );

  const className = clsx(propClassName, breedClassName);

  return <Text {...breedProps} {...rest} className={className} />;
};
